import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useApiCall } from "../services/api";
import { useSelector } from "react-redux";
import { reporStaticData } from "../common/DataReports";

const answerQuesMapping = {
  l1: [4],
  l2: [5],
  l3: [6],
  acpt: [2],
  customerVoc: [3],
  dispositionAccuracy: [1, 18, 23],
  callObservation: [7],
  feedback: [8, 22, 26],
  fatalReason: [9],
  remarks: [21, 25],
  ncCall: [20],
  rfd_identified_id: [27],
  probing_id: [28],
  negotiation_id: [29],
  urgency_id: [30],
  rebuttals_id: [31],
  on_call_attempt_id: [32],
  soft_skills_issue_id: [33],
  casual_choice_of_words_identified_id: [34],
  customer_behaviour_id: [35],
  call_quality_rag_id: [36],
  aoi_id: [37],
  payment_expected_date: [38],
};

const showDecryptedLogs = process.env.REACT_APP_LOG_DECRYPTED_DATA === "true";

const AnswersComp = ({ answers, isAuditPage }) => {
  const tempanswers = [
    { id: 1, question: "Question 1", isCorrect: true, rightAns: "hello", bottomAns: "world" },
    { id: 2, question: "Question 2", rightAns: "Connected", isCorrect: true },
    { id: 3, question: "Question 3", rightAns: "Answer 3", isCorrect: true },
    { id: 4, question: "Question 4", rightAns: "Something else" },
    { id: 5, question: "Question 5", rightAns: "Unsure" },
  ];

  return (
    <>
      {isAuditPage && (
        <div className="answers-comp mt-4" style={{ borderRadius: "10px", overflow: "hidden", border: "1px solid #d9d9d9" }}>
          <table className="w-100" style={{ borderCollapse: "separate", borderSpacing: 0, fontSize: "12px" }}>
            <thead>
              <tr style={{ backgroundColor: "#052659", color: "#fff" }}>
                <th style={{ padding: "12px", textAlign: "left", borderBottom: "1px solid #d9d9d9", width: "70%" }}>
                  Questions
                </th>

                <th style={{ padding: "12px", textAlign: "left", borderBottom: "1px solid #d9d9d9" }}>
                  QA Response
                </th>

                <th style={{ padding: "12px", textAlign: "left", borderBottom: "1px solid #d9d9d9" }}>
                  QL Response
                </th>
              </tr>
            </thead>

            <tbody>
              {answers.map((answer, index) => (
                <tr key={answer.id}>
                  <td style={{ padding: "10px 12px", borderBottom: index !== answers.length - 1 ? "1px solid #d9d9d9" : "none", fontWeight: 500 }}>
                    {answer.question}
                  </td>

                  <td style={{ padding: "10px 12px", borderLeft: "1px solid #d9d9d9", borderRight: "1px solid #d9d9d9", borderBottom: index !== answers.length - 1 ? "1px solid #d9d9d9" : "none" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", whiteSpace: "nowrap" }}>
                      {answer.isCorrect && (
                        <img src="/assets/charm_circle-tick.png" alt="Check" width={16} />
                      )}

                      <span>{answer.qaanswer || "-"}</span>

                      {answer.bottomAns && (
                        <span style={{ color: "#00C853", fontSize: 11, border: "1px solid #00C853", padding: "2px 6px", borderRadius: 4 }}>
                          {answer.bottomAns}
                        </span>
                      )}
                    </div>
                  </td>

                  <td style={{ padding: "10px 12px", borderBottom: index !== answers.length - 1 ? "1px solid #d9d9d9" : "none" }}>
                    <div className="d-flex align-items-center gap-2">
                      {answer.isCorrect && (
                        <img src="/assets/charm_circle-tick.png" alt="Check" width={16} />
                      )}

                      <span>{answer.qlanswer || answer.rightAns || "-"}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!isAuditPage && (
        <div className="answers-comp mt-4">
          <h5
            className="font-weight-bold p-3"
            style={{
              backgroundColor: "#052659",
              color: "white",
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px",
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            Answers
          </h5>
          <div className="d-flex flex-column border">
            {answers.map((answer) => (
              <div className="border-bottom p-3" key={answer.id} style={{ fontSize: 12 }}>
                <div className="d-flex justify-content-between w-100">
                  <div className="font-weight-bold">{answer.question}</div>
                  <div className="font-weight-bold d-flex align-items-center gap-2">
                    {answer.isCorrect && (
                      <img src="/assets/charm_circle-tick.png" alt="Check Icon" width={20} />
                    )}
                    <span className="text-end">{answer.rightAns}</span>
                  </div>
                </div>
                {answer.bottomAns && (
                  <div className="d-flex mt-1" style={{ color: "#00C853", fontSize: 12 }}>
                    <span className="border p-1 ">{answer.bottomAns}</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

    </>

  );
};

const ScoreComp = ({ answers, isAuditPage }) => {
  const categorizedAnswers = [
    {
      id: 1,
      categoryName: "Category 1",
      questions: [
        { id: 1, question: "Question 1", score: 2 },
        { id: 2, question: "Question 2", score: 2 },
        { id: 3, question: "Question 3", score: 2 },
      ],
    },
    {
      id: 2,
      categoryName: "Category 1",
      questions: [
        { id: 1, question: "Question 1", score: 2 },
        { id: 2, question: "Question 2", score: 2 },
        { id: 3, question: "Question 3", score: 2 },
      ],
    },
  ];
  return (
    <>
      {isAuditPage && (
        <div className="score-comp mt-4" style={{ borderRadius: "10px", overflow: "hidden", border: "1px solid #d9d9d9" }}>
          <table className="w-100" style={{ borderCollapse: "separate", borderSpacing: 0, fontSize: "12px" }}>
            <thead>
              <tr style={{ backgroundColor: "#052659", color: "#fff" }}>
                <th style={{ padding: "14px", textAlign: "left", width: "70%", fontWeight: 600 }}>Score</th>

                <th style={{ padding: "14px", textAlign: "center", borderLeft: "1px solid #0d3b7a", fontWeight: 600, whiteSpace: "nowrap", width: "15%" }}>
                  QA Response
                </th>

                <th style={{ padding: "14px", textAlign: "center", borderLeft: "1px solid #0d3b7a", fontWeight: 600, whiteSpace: "nowrap", width: "15%" }}>
                  QL Response
                </th>
              </tr>
            </thead>

            <tbody>
              {answers?.map((category) => (
                <React.Fragment key={category.categoryId}>
                  <tr style={{ backgroundColor: "#C1E8FF" }}>
                    <td style={{ padding: "14px", fontWeight: 600, borderBottom: "1px solid #d9d9d9" }}>
                      {category.categoryName}
                    </td>

                    <td style={{ padding: "14px", textAlign: "center", borderLeft: "1px solid #d9d9d9", borderBottom: "1px solid #d9d9d9", fontWeight: 600 }}>
                      {category.qaScore === -1 ? "N/A" : category.qaScore || 0}
                    </td>

                    <td style={{ padding: "14px", textAlign: "center", borderLeft: "1px solid #d9d9d9", borderBottom: "1px solid #d9d9d9", fontWeight: 600 }}>
                      {category.qlScore === -1 ? "N/A" : category.qlScore || 0}
                    </td>
                  </tr>

                  {category.questions.map((question, index) => (
                    <tr key={question.questionId}>
                      <td style={{ padding: "16px 14px", borderBottom: "1px solid #d9d9d9", fontWeight: question.fatal === 1 ? 600 : 400 }}>
                        {question.question}
                      </td>

                      <td style={{ padding: "16px 14px", textAlign: "center", borderLeft: "1px solid #d9d9d9", borderBottom: "1px solid #d9d9d9" }}>
                        {question.qaScore === -1 ? "N/A" : question.qaScore || ""}
                      </td>

                      <td style={{ padding: "16px 14px", textAlign: "center", borderLeft: "1px solid #d9d9d9", borderBottom: "1px solid #d9d9d9" }}>
                        {question.qlScore === -1 ? "N/A" : question.qlScore || ""}
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {!isAuditPage && (
        <div className="score-comp mt-4">
          <h5
            className="font-weight-bold p-3"
            style={{
              backgroundColor: "#052659",
              color: "white",
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px",
              fontWeight: "600",
              fontSize: 14,
            }}
          >
            Score
          </h5>
          {answers
            // ?.filter((q) => q.questions.length)
            ?.map((category) => (
              <div key={category.categoryId}>
                <h6
                  className="font-weight-bold p-3 border d-flex justify-content-between"
                  style={{ backgroundColor: "#C1E8FF" }}
                >
                  <span style={{ fontWeight: 600, fontFamily: "Gilroy-Bold", fontSize: 14 }}>
                    {category.categoryName}
                  </span>
                  <span style={{ fontWeight: 600, fontFamily: "Gilroy-Bold", fontSize: 14 }}>
                    {category.obtainedScore === -1 ? "N/A" : category.obtainedScore}
                  </span>
                </h6>
                {category.questions.map((question) => (
                  <div
                    className="d-flex justify-content-between p-3 border"
                    key={question.questionId}
                    style={{ fontSize: 12 }}
                  >
                    <div className={`${question.fatal === 1 ? "fw-bold" : ""}`}>
                      {question.question}
                    </div>
                    <div className="">{question.score === -1 ? "N/A" : question.score}</div>
                  </div>
                ))}
              </div>
            ))}
        </div>

      )}
    </>
  );
};
const CalibrationAnswersComp = ({ answers, isAuditPage }) => {
  // Check if the response has sections (array of objects with 'section' property)
  const hasSections = answers && answers.length > 0 && answers[0]?.section !== undefined;
  
  // Check if it's direct format (array of objects with 'question' property)
  const isDirectFormat = answers && answers.length > 0 && answers[0]?.question !== undefined;

  return (
    <>
      {isAuditPage && (
        <div className="answers-comp mt-4" style={{ borderRadius: "8px", overflow: "hidden"}}>
          <table className="w-100" style={{ borderCollapse: "collapse", fontSize: "12px" }}>
            <thead>
              <tr style={{ backgroundColor: "#052659", color: "#fff" }}>
                <th style={{ padding: "12px", textAlign: "left", width: "40%", whiteSpace: "nowrap"}}>Questions</th>
                <th style={{ padding: "12px", textAlign: "center",whiteSpace: "nowrap" }}>Master Auditor Response</th>
                <th style={{ padding: "12px", textAlign: "center", whiteSpace: "nowrap" }}>Ops Team Lead Response</th>
                <th style={{ padding: "12px", textAlign: "center",  whiteSpace: "nowrap"}}>Ops Team Response</th>
                <th style={{ padding: "12px", textAlign: "center", whiteSpace: "nowrap" }}>Trainer Response</th>
                <th style={{ padding: "12px", textAlign: "center", whiteSpace: "nowrap" }}>Trainer Lead Response</th>
                <th style={{ padding: "12px", textAlign: "center", whiteSpace: "nowrap" }}>Quality Analyst Response</th>
              </tr>
            </thead>

            <tbody>
              {answers?.map((section, sectionIndex) => (
                <React.Fragment key={sectionIndex}>
                  <tr style={{ backgroundColor: "#C1E8FF" }}>
                    <td colSpan={7} style={{ padding: "10px 12px", fontWeight: 600, border: "1px solid #d9d9d9", fontSize: "13px" }}>
                      {section.section}
                    </td>
                  </tr>

                  {section.questions?.map((item, qIndex) => (
                    <tr key={qIndex}>
                      <td style={{ padding: "10px 12px", border: "1px solid #d9d9d9", fontWeight: 500 }}>
                        {item.question}
                      </td>

                       <td style={{ padding: "10px", border: "1px solid #d9d9d9", textAlign: "center" }}>
                        {item.master_answer}
                      </td> 

                      <td style={{ padding: "10px", border: "1px solid #d9d9d9", textAlign: "center" }}>
                        {item.opsteamlead_answer}
                      </td>

                      <td style={{ padding: "10px", border: "1px solid #d9d9d9", textAlign: "center" }}>
                        {item.opslead_answer}
                      </td>

                      <td style={{ padding: "10px", border: "1px solid #d9d9d9", textAlign: "center" }}>
                        {item.trainer_answer}
                      </td>

                      <td style={{ padding: "10px", border: "1px solid #d9d9d9", textAlign: "center" }}>
                        {item.traininglead_answer}
                      </td>

                      <td style={{ padding: "10px", border: "1px solid #d9d9d9", textAlign: "center" }}>
                        {item.qa_answer}
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!isAuditPage && (
        <div className="answers-comp mt-4">
          <h5
            className="font-weight-bold p-3"
            style={{
              backgroundColor: "#052659",
              color: "white",
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px",
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            Q&A Response
          </h5>
          <div className="d-flex flex-column border">
            {hasSections ? (
              // Section-wise format
              answers.map((section, sectionIndex) => (
                <div key={sectionIndex} className="mb-3">
                  <h6
                    className="font-weight-bold p-2"
                    style={{
                      backgroundColor: "#C1E8FF",
                      margin: 0,
                      fontSize: "13px",
                      fontWeight: "600",
                    }}
                  >
                    {section.section}
                  </h6>
                  <div className="border">
                    {section.questions?.map((item, qIndex) => (
                      <div
                        className="border-bottom p-3"
                        key={qIndex}
                        style={{ fontSize: 12 }}
                      >
                        <div className="d-flex justify-content-between w-100">
                          <div className="font-weight-bold" style={{ width: "70%" }}>
                            {item.question}
                          </div>
                          <div className="font-weight-bold d-flex align-items-center gap-2">
                            <span className="text-end">{item.answer}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            ) : (
              // Direct format
              answers?.map((item, index) => (
                <div className="border-bottom p-3" key={index} style={{ fontSize: 12 }}>
                  <div className="d-flex justify-content-between w-100">
                    <div className="font-weight-bold" style={{ width: "70%" }}>
                      {item.question}
                    </div>
                    <div className="font-weight-bold d-flex align-items-center gap-2">
                      <span className="text-end">{item.answer}</span>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}

    </>
    
    
  );
};

const ReportPdf = ({ type = "transactional", reportRef }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { callApi } = useApiCall();
  const [searchParams] = useSearchParams();
  const callId = searchParams.get("callId");
  const auditTypeId = searchParams.get("auditTypeId");
   const roleId = searchParams.get("roleId");
  const role = useSelector((state) => state.auth.role);

  // const [reportData, setReportData] = useState({
  //   l1: "Behavorial Issue",
  //   l2: "Probing Missing",
  //   l3: "test",
  //   acpt: "Process/Product",
  //   week: null,
  //   empId: "EM12",
  //   callId: 139,
  //   center: "BLR-TRELINE",
  //   ncCall: true,
  //   auditId: 117,
  //   recPath:
  //     "https://drive.google.com/file/d/1-oo3YamHQAn_ggtwy9Gqpuzyelj1N9MW/view?usp=drive_link",
  //   remarks: "Agent needs retraining on greeting protocol",
  //   callDate: "2025-07-25",
  //   callType: "Outgoing",
  //   duration: "00:00:31",
  //   feedback: "Yes",
  //   hangUpBy: "CUSTOMER",
  //   agentName: "Agent_1",
  //   auditDate: "2025-08-26",
  //   auditType: "Transformational",
  //   createdAt: "2025-08-29T10:26:00.381026",
  //   auditorName: "Kamlesh QA hashed",
  //   customerVoc: "Cred App Issue",
  //   disposition: "Paid",
  //   fatalReason: "test",
  //   mobileNumber: "9003420116",
  //   fatalNonFatal: "Fatal",
  //   subDisposition: "Foreclosed",
  //   callObservation: "test",
  //   actualDisposition: "2",
  //   dispositionAccuracy: "Incorrect",
  // });

  const [reportData, setReportData] = useState({});
  const [questions, setQuestions] = useState([]);
  const [readyToPrint, setReadyToPrint] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const isCalibrationMode = searchParams.get("isCalibrationMode") === "true";
  const isAuditPage = searchParams.get("isAuditPage") === "true";

  // for audit type: 1
  // const report = {
  //   week: 34,
  //   empId: "E123",
  //   callId: 197,
  //   center: "Mumbai",
  //   auditId: 86,
  //   recPath: "/recordings/call1001.ogg",
  //   callDate: "2025-08-20",
  //   callType: "Inbound",
  //   duration: "300",
  //   hangUpBy: "Customer",
  //   agentName: "John Doe",
  //   auditDate: "2025-08-21",
  //   auditType: "Transactional",
  //   createdAt: "2025-08-22T13:00:42.575925",
  //   evaluation: [
  //     {
  //       questions: [
  //         {
  //           risk: "LRD",
  //           fatal: 0,
  //           score: 2,
  //           question: "Call Opening within threshold",
  //           weightage: 2,
  //           questionId: 101,
  //         },
  //         {
  //           risk: "LRD",
  //           fatal: 0,
  //           score: 1,
  //           question: "Self & Company Introduction",
  //           weightage: 1,
  //           questionId: 102,
  //         },
  //         {
  //           risk: "HRD",
  //           fatal: 0,
  //           score: 0,
  //           question: "Verification of Customer Identification",
  //           weightage: 0,
  //           questionId: 103,
  //         },
  //         {
  //           risk: "LRD",
  //           fatal: 0,
  //           score: 2,
  //           question: "Recording Line Disclaimer",
  //           weightage: 2,
  //           questionId: 104,
  //         },
  //       ],
  //       categoryId: 1,
  //       categoryName: "Introduction & Validation",
  //       obtainedScore: 5,
  //       totalWeightage: 5,
  //     },
  //     {
  //       questions: [
  //         {
  //           risk: "LRD",
  //           fatal: 0,
  //           score: 2,
  //           question: "Reason for Default Identification",
  //           weightage: 2,
  //           questionId: 201,
  //         },
  //         {
  //           risk: "LRD",
  //           fatal: 0,
  //           score: 2,
  //           question: "Relevant Product Info Accuracy",
  //           weightage: 2,
  //           questionId: 202,
  //         },
  //         {
  //           risk: "HRD",
  //           fatal: 0,
  //           score: 0,
  //           question: "Call Avoidance",
  //           weightage: 0,
  //           questionId: 203,
  //         },
  //         {
  //           risk: "LRD",
  //           fatal: 0,
  //           score: 2,
  //           question: "Active Listening & Avoidance of Dead Air",
  //           weightage: 2,
  //           questionId: 204,
  //         },
  //         {
  //           risk: "LRD",
  //           fatal: 0,
  //           score: 2,
  //           question: "Provided pending due date & amount",
  //           weightage: 2,
  //           questionId: 205,
  //         },
  //         {
  //           risk: "LRD",
  //           fatal: 0,
  //           score: 1,
  //           question: "Usage of customer's preferred Language",
  //           weightage: 2,
  //           questionId: 206,
  //         },
  //         {
  //           risk: "LRD",
  //           fatal: 0,
  //           score: 1,
  //           question: "Acknowledging customer concern",
  //           weightage: 2,
  //           questionId: 207,
  //         },
  //       ],
  //       categoryId: 2,
  //       categoryName: "Customer Relationship Building",
  //       obtainedScore: 10,
  //       totalWeightage: 12,
  //     },
  //     {
  //       questions: [
  //         {
  //           risk: "MRD",
  //           score: 5,
  //           question: "Relevant Negotiation",
  //           weightage: 5,
  //           questionId: 301,
  //         },
  //         {
  //           risk: "MRD",
  //           score: 5,
  //           question: "Provision of relevant payment options",
  //           weightage: 5,
  //           questionId: 302,
  //         },
  //         {
  //           risk: "MRD",
  //           score: 4,
  //           question: "Provision of non repayment consequences",
  //           weightage: 5,
  //           questionId: 303,
  //         },
  //         {
  //           risk: "MRD",
  //           score: 4,
  //           question: "Attempts of on call payment",
  //           weightage: 5,
  //           questionId: 304,
  //         },
  //       ],
  //       categoryId: 3,
  //       categoryName: "Collections Efforts",
  //       obtainedScore: 18,
  //       totalWeightage: 20,
  //     },
  //     {
  //       questions: [
  //         {
  //           risk: "LRD",
  //           score: 2,
  //           question: "Assertive & respectful tone",
  //           weightage: 2,
  //           questionId: 401,
  //         },
  //         {
  //           risk: "HRD",
  //           score: 0,
  //           question: "Avoid Misleading Info",
  //           weightage: 0,
  //           questionId: 402,
  //         },
  //         {
  //           risk: "LRD",
  //           score: 2,
  //           question: "Casual words/grammar errors",
  //           weightage: 2,
  //           questionId: 403,
  //         },
  //         {
  //           risk: "LRD",
  //           score: 2,
  //           question: "Confidence & Enthusiasm",
  //           weightage: 2,
  //           questionId: 404,
  //         },
  //         { risk: "LRD", score: 1, question: "High Rate of speech", weightage: 2, questionId: 405 },
  //         { risk: "LRD", score: 1, question: "Empathy to customer", weightage: 2, questionId: 406 },
  //         {
  //           risk: "LRD",
  //           score: 2,
  //           question: "Limited interruptions",
  //           weightage: 2,
  //           questionId: 407,
  //         },
  //         { risk: "LRD", score: 2, question: "Formal Call Closing", weightage: 2, questionId: 408 },
  //       ],
  //       categoryId: 4,
  //       categoryName: "Soft Skills & Process Adherence",
  //       obtainedScore: 12,
  //       totalWeightage: 14,
  //     },
  //     {
  //       questions: [
  //         {
  //           risk: "MRD",
  //           score: 10,
  //           question: "Disposition Accuracy",
  //           weightage: 10,
  //           questionId: 501,
  //         },
  //         {
  //           risk: "LRD",
  //           score: 1,
  //           question: "Redirect disputes to SPOC",
  //           weightage: 2,
  //           questionId: 502,
  //         },
  //         {
  //           risk: "LRD",
  //           score: 1,
  //           question: "Pre schedule follow up calls",
  //           weightage: 2,
  //           questionId: 503,
  //         },
  //       ],
  //       categoryId: 5,
  //       categoryName: "Post Call Evaluation",
  //       obtainedScore: 12,
  //       totalWeightage: 14,
  //     },
  //     {
  //       questions: [
  //         {
  //           risk: "ZTP",
  //           score: 0,
  //           question: "Rude/abusive language",
  //           weightage: 0,
  //           questionId: 601,
  //         },
  //         {
  //           risk: "ZTP",
  //           score: 0,
  //           question: "Sharing proprietary info",
  //           weightage: 0,
  //           questionId: 602,
  //         },
  //         {
  //           risk: "ZTP",
  //           score: 0,
  //           question: "Unfair productivity means",
  //           weightage: 0,
  //           questionId: 603,
  //         },
  //         { risk: "ZTP", score: 0, question: "Denied resolution", weightage: 0, questionId: 604 },
  //         {
  //           risk: "ZTP",
  //           score: 0,
  //           question: "Irrelevant internal topics",
  //           weightage: 0,
  //           questionId: 605,
  //         },
  //         {
  //           risk: "ZTP",
  //           score: 0,
  //           question: "Unrealistic expectations",
  //           weightage: 0,
  //           questionId: 606,
  //         },
  //       ],
  //       categoryId: 6,
  //       categoryName: "ZTP Parameters",
  //       obtainedScore: 0,
  //       totalWeightage: 14,
  //     },
  //   ],
  //   auditorName: "Kamlesh QA hashed",
  //   mobileNumber: "9876543210",
  // };

  // for audit type: 2,3,4
  // const report = {
  //   l1: "Behavorial Issue",
  //   l2: "Probing Missing",
  //   l3: "test",
  //   acpt: "Process/Product",
  //   week: null,
  //   empId: "EM12",
  //   callId: 139,
  //   center: "BLR-TRELINE",
  //   ncCall: true,
  //   auditId: 117,
  //   recPath:
  //     "https://drive.google.com/file/d/1-oo3YamHQAn_ggtwy9Gqpuzyelj1N9MW/view?usp=drive_link",
  //   remarks: "Agent needs retraining on greeting protocol",
  //   callDate: "2025-07-25",
  //   callType: "Outgoing",
  //   duration: "00:00:31",
  //   feedback: "Yes",
  //   hangUpBy: "CUSTOMER",
  //   agentName: "Agent_1",
  //   auditDate: "2025-08-26",
  //   auditType: "Transformational",
  //   createdAt: "2025-08-29T10:26:00.381026",
  //   auditorName: "Kamlesh QA hashed",
  //   customerVoc: "Cred App Issue",
  //   disposition: "Paid",
  //   fatalReason: "test",
  //   mobileNumber: "9003420116",
  //   fatalNonFatal: "Fatal",
  //   subDisposition: "Foreclosed",
  //   callObservation: "test",
  //   actualDisposition: "2",
  //   dispositionAccuracy: "Incorrect",
  // };

  const formatAnswer = (value) => {
    if (value === true) return "Yes";
    if (value === false) return "No";
    return value || "--";
  };

  const answers = Object.entries(answerQuesMapping).flatMap(([key, qids]) =>
    qids
      .map((qid) => {
        const question = questions.find((q) => q.id === qid);

        if (!question) return null;

        const baseData = {
          id: qid,
          type: key,
          question: question.question,
          options: question.options || [],
        };

        if (isAuditPage) {
          return {
            ...baseData,
            qlanswer: formatAnswer(reportData?.ql_response?.[key]),
            qaanswer: formatAnswer(reportData?.qa_response?.[key]),
          };
        }

        const answer = formatAnswer(reportData?.[key]);

        return {
          ...baseData,
          answer,
          rightAns: answer,
        };
      })
      .filter(Boolean)
  );



useEffect(() => {
  if (!callId || !auditTypeId) return navigate("/complete-calls");

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    
    try {
      // For qualitylead and qualityassurance roles, always use old API regardless of isCalibrationMode
      const shouldUseOldApi = role === 'qualitylead' || role === 'qualityassurance' || role === 'super_admin' ;
  
      let apiendPoints;
      if (shouldUseOldApi && roleId) {
        // qualitylead and qualityassurance always use old API
        apiendPoints = 'call-audits/get-audited-audit-details';
      }else if(shouldUseOldApi){
       apiendPoints = 'call-audits/get-call-audit-data';
      } else {
        // For other roles, use logic based on isCalibrationMode
        apiendPoints = (isCalibrationMode || role === 'opsteamlead' || role === 'traininglead' || role === 'trainer' || role === 'opslead') 
          ? 'call-audits/get-call-calibration-audit-details' 
          : 'call-audits/get-call-audit-data';
      }

      const { responseData, status } = await callApi({
        endpoint: apiendPoints,
        queryParams: {
          callId: callId,
          auditTypeId: auditTypeId,
          roleid:roleId,
          isAtaReport: !isCalibrationMode && isAuditPage ? true:false,
          isCalibrationReport: isCalibrationMode && isAuditPage?true:false
        },
        showToast: false,
      });

      if (status && responseData?.data) {
        setReportData(responseData.data);
        setError(null);
      } else {
        // No data found - show user-friendly message
        setError(isCalibrationMode 
          ? "This call has not been audited for Calibration Report yet."
          : "No audit data found for this call.");
        setReportData({});
        setLoading(false);
        return;
      }

      if (auditTypeId === 1) {
        setLoading(false);
        return;
      }

      const { response: questionRes, status: questionStatus } = await callApi({
        endpoint: `call-audits/${auditTypeId}/questions`,
        showToast: false,
      });

      if (questionStatus) {
        setQuestions(questionRes.data?.data || []);
      }

      if (status && questionStatus) {
        setReadyToPrint(true);
      }
    } catch (err) {
      console.error("Error fetching report data:", err);
      setError(isCalibrationMode 
        ? "Unable to load Calibration Report. The call may not have been calibrated yet."
        : "Unable to load report data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [callId, auditTypeId, role, isCalibrationMode]);

  // useEffect(() => {
  //   if (readyToPrint && reportData) {
  //     setTimeout(() => {
  //       window.print();

  //       window.close();
  //     }, 1000);
  //   }
  // }, [readyToPrint, reportData]);

  // Show loading state
  if (loading) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Loading report data...</p>
      </div>
    );
  }

  // Show simple message when no data found
  if (error || !reportData || Object.keys(reportData).length === 0) {
    return (
      <div className="container py-5 text-center">
        <div className="alert alert-info" style={{ maxWidth: "500px", margin: "0 auto", backgroundColor: "#e8f4fd", borderColor: "#b8e1fc" }}>
          <p className="mb-0" style={{ color: "#0c5e8c" }}>
            <i className="bi bi-info-circle-fill me-2"></i>
            {isCalibrationMode 
              ? "This call has not been calibrated yet."
              : "No audit data found for this call."}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      ref={reportRef}
      className="report-pdf d-flex flex-column px-5 py-3"
      style={{ fontFamily: "Gilroy-Medium" }}
    >
      <button
        className="btn btn-primary d-flex ms-auto"
        id="download-pdf-btn"
        onClick={() => {
          window.print();
        }}
        style={{
          position: "absolute",
          backgroundColor: "#052659",
          color: "white",
          border: "none",
          borderRadius: "5px",
          padding: "10px 20px",
          fontWeight: "600",
          width: "fit-content",
          right: "20px",
          top: "20px",
        }}
      >
        Download PDF
      </button>
      <div className="d-flex justify-content-center">
        <img src="/assets/logo.png" width={200} />
      </div>
      <div className="my-3 mt-5">
        <h2
          className="font-weight-bold"
          style={{ fontWeight: "600", fontFamily: "Gilroy-Bold", color: "#052659" }}
        >
          Call report
        </h2>
      </div>
      <div style={{ fontSize: "14px", color: "black", fontWeight: "500" }}>
        <div className="my-3 d-flex justify-content-between">
          <p>
            Reviewed By:{" "}
            <span style={{ textDecoration: "underline", color: "#808080" }}>
              {reportData?.auditorName}
            </span>
          </p>
          <p className="font-weight-bold">
            Review date:{" "}
            <span style={{ textDecoration: "underline", color: "#808080" }}>
              {reportData?.auditDate}
            </span>
          </p>
        </div>
        <div className="mt-5 px-3 ">
          <div className="d-flex justify-content-between">
            <p className="font-weight-bold">Agent Name</p>
            <p className="font-weight-bold">{reportData?.agentName}</p>
          </div>
          <hr className="my-2" />
          <div className="d-flex justify-content-between">
            <p className="font-weight-bold">Call type</p>
            <p className="font-weight-bold">{reportData?.auditType}</p>
          </div>
          <hr className="my-2" />
          <div className="d-flex justify-content-between">
            <p className="font-weight-bold">Call ID</p>
            <p className="font-weight-bold">{reportData?.callId}</p>
          </div>
          <hr className="my-2" />
          <div className="d-flex justify-content-between">
            <p className="font-weight-bold">Call duration</p>
            <p className="font-weight-bold">{reportData?.duration}</p>
          </div>
          {reportData?.remarks && (
            <>
              <hr className="my-2" />
              <div className="d-flex justify-content-between">
                <p className="font-weight-bold">Remarks</p>
                <p className="font-weight-bold">{reportData?.remarks}</p>
              </div>
            </>
          )}
          <hr className="my-2" />
        </div>
      </div>
     {auditTypeId === "1" && isCalibrationMode ? (
        <CalibrationAnswersComp answers={reportData?.ql_audit_response || []} isAuditPage={isAuditPage} />
      ) : auditTypeId === "1" ? (
        <ScoreComp answers={reportData?.evaluation} isAuditPage={isAuditPage} />
      ) : (isCalibrationMode && (role === 'qualitylead' || role === 'qualityassurance' || role === 'super_admin')) ? (
        <CalibrationAnswersComp answers={reportData?.ql_audit_response || []} isAuditPage={isAuditPage} />
      ) : isCalibrationMode ? (
        <CalibrationAnswersComp answers={reportData?.ql_audit_response || []} isAuditPage={isAuditPage} />
      ) : (
        <AnswersComp answers={answers} isAuditPage={isAuditPage} />
      )}
      <p className="mt-4" style={{ color: "#052659", fontWeight: "500", fontFamily: "Gilroy" }}>
        Generated by Aastraa QA System
      </p>
    </div>
  );
};

export default ReportPdf;
